import { render } from "./TableFilters.vue?vue&type=template&id=2b40f44d&scoped=true"
import script from "./TableFilters.vue?vue&type=script&lang=js"
export * from "./TableFilters.vue?vue&type=script&lang=js"

import "./TableFilters.vue?vue&type=style&index=0&id=2b40f44d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b40f44d"]])

export default __exports__